// Module
var code = "<overview ng-if=\"!OverviewAndMemberDetails.state.selectedMember.SubscriberId\"></overview>\n<member-details ng-if=\"OverviewAndMemberDetails.state.selectedMember.SubscriberId\"></member-details>\n";
// Exports
module.exports = code;